import { getQueryStringHashToObject, failureAction } from '../../app-actions';
import { apiGet, apiPost } from '../../api/api-configuration';
import {
  API_INITIATE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT,
  API_GET_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT,
  API_COMPLETE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT,
  API_POST_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT,
  API_COMPLETE_SUBMIT_BUSINESS_POP_MAIL,
  API_INITIATE_SUBMIT_BUSINESS_POP_MAIL,
} from '../../app-constants';
import { validatePhoneNumber } from '../ssm-homepage/ssm-homepage.actions';

export const getUserId = () => {
  const parsedHash = getQueryStringHashToObject(window.location.hash);
  const {
    userId,
  } = parsedHash;
  return userId;
};

export const successBusinessPopMail = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT, data };
};


const getBusinessPopMail = data => (dispatch) => {
  const userId = getUserId();
  const endpoint = `${API_GET_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT}?userId=${userId}`;
  dispatch({ type: API_INITIATE_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT });
  apiGet(dispatch, endpoint, successBusinessPopMail, failureAction, data);
};

export const successActionSubmitBusinessPopMail = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_SUBMIT_BUSINESS_POP_MAIL, data };
};

export const submitBusinessPopMail = data => (dispatch) => {
  const endpoint = API_POST_BUSINESS_POP_MAIL_CUSTOMER_DATA_ENDPOINT;
  dispatch({ type: API_INITIATE_SUBMIT_BUSINESS_POP_MAIL });
  apiPost(dispatch, endpoint, successActionSubmitBusinessPopMail, failureAction, data);
};

export const prepareSubmitData = (emailList, emailSelectionsData, captchaToken, contactFormValue) => {
  let atleastOneMigratePresent = false;
  const emailSubmissionData = emailList.map((email) => {
    const option = emailSelectionsData[email] === 'Migrate' ? 'M' : 'C';
    if (!atleastOneMigratePresent) {
      atleastOneMigratePresent = emailSelectionsData[email] === 'Migrate';
    }
    return { mailbox: email, action: option };
  });

  const dataForSubmission = {
    userId: getUserId(),
    selection: emailSubmissionData,
    firstName: (atleastOneMigratePresent) ? contactFormValue.firstName : '',
    lastName: (atleastOneMigratePresent) ? contactFormValue.lastName : '',
    contactNumber: (atleastOneMigratePresent) ? contactFormValue.contactField : '',
    emailAddress: (atleastOneMigratePresent) ? contactFormValue.email : '',
    accountNumber: (atleastOneMigratePresent) ? contactFormValue.accountNumber : '',
    billingAddress: (atleastOneMigratePresent) ? contactFormValue.billingAddress : '',
    abnNumber: (atleastOneMigratePresent) ? contactFormValue.abnNumber : '',
    gCaptchaToken: captchaToken,
  };

  return dataForSubmission;
};

export const prepareContactFormArr = () => {
  const contactFormValue = {
    firstName: '',
    contactField: '',
    lastName: '',
    email: '',
    accountNumber: '',
    abnNumber: '',
    billingAddress: '',
  };
  const contactFormError = {
    firstName: false,
    contactField: false,
    lastName: false,
  };

  return {
    contactFormValue,
    contactFormError,
  };
};

export const validateContactForm = (atleastOneMigratePresent, formValue, formError) => {
  let error = false;
  const formErrors = formError;
  if (atleastOneMigratePresent) {
    Object.keys(formError).map((feilds) => {
      let validateError = false;
      if (feilds === 'contactField') {
        validateError = !validatePhoneNumber(formValue[feilds]) || formValue[feilds].length !== 10;
      } else if (formValue[feilds] === '') {
        validateError = true;
      }
      formErrors[feilds] = validateError;
      if (validateError === true) {
        error = true;
      }
      return true;
    });
  }

  return {
    error,
    formErrors,
  };
};

export default getBusinessPopMail;
